import api from './api';
import { ApiResponse } from '../types';

// ---- Tipos del Dashboard ----

export interface CashBoxSummary {
  id: number;
  name: string;
  currency: string;
  balance: number;
}

export interface FinancialSummary {
  totalBalanceARS: number;
  totalBalanceUSD: number;
  cashBoxes: CashBoxSummary[];
}

export interface SalesSummary {
  totalSales: number;
  totalSalesAmountARS: number;
  totalSalesAmountUSD: number;
  salesThisMonth: number;
}

export interface InstallmentsSummary {
  overdueCount: number;
  overdueTotal: number;
  upcomingNext30DaysCount: number;
  upcomingNext30DaysTotal: number;
  paidThisMonthCount: number;
  paidThisMonthTotal: number;
  totalPendingCount: number;
}

export interface PurchaseOrdersSummary {
  totalOrders: number;
  draftCount: number;
  sentCount: number;
  receivedCount: number;
  cancelledCount: number;
  totalAmountARS: number;
  totalAmountUSD: number;
}

export interface SupplierInvoicesSummary {
  totalInvoices: number;
  pendingCount: number;
  partiallyPaidCount: number;
  paidCount: number;
  totalPendingAmountARS: number;
  totalPendingAmountUSD: number;
}

export interface ProjectsSummary {
  totalProjects: number;
  totalFunctionalUnits: number;
  soldFunctionalUnits: number;
  availableFunctionalUnits: number;
}

export interface EntityCounts {
  activeCustomers: number;
  totalCustomers: number;
  activeSuppliers: number;
  totalSuppliers: number;
}

export interface RecentTransaction {
  id: number;
  type: string;
  status: string;
  description: string;
  currency: string;
  amount: number;
  accountingDate: string;
  executedAt: string;
}

export interface DashboardDTO {
  financialSummary: FinancialSummary;
  salesSummary: SalesSummary;
  installmentsSummary: InstallmentsSummary;
  purchaseOrdersSummary: PurchaseOrdersSummary;
  supplierInvoicesSummary: SupplierInvoicesSummary;
  projectsSummary: ProjectsSummary;
  entityCounts: EntityCounts;
  recentTransactions: RecentTransaction[];
}

const dashboardService = {
  getDashboard: async (): Promise<DashboardDTO> => {
    try {
      const response = await api.get<ApiResponse<DashboardDTO>>('/dashboard');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching dashboard:', error);
      throw error;
    }
  },
};

export default dashboardService;
